import toast from "react-hot-toast";
import React from "react";
import { PremiumToast } from "../components/Common/PremiumToast";

const Toast = (message, type = "success") => {
  const toastType = ["success", "error", "loading", "custom"].includes(type)
    ? type
    : "success";

  toast.custom(
    (t) =>
      React.createElement(PremiumToast, { t, message, type: toastType }),
    {
      duration: toastType === "error" ? 4200 : 3600,
      position: "top-right",
    }
  );
};

export default Toast;
